import { B as Button, c as chevronTemplateFactory, b as buttonDefinition } from './definition11.js';
import { P as Popup, p as popupDefinition } from './definition65.js';
import { I as Icon, i as iconDefinition } from './definition28.js';
import { V as VividElement, O as Observable, D as DOM, a as attr, n as nullableNumberConverter, o as observable, h as html, d as createRegisterFunction, f as defineVividComponent } from './vivid-element.js';
import { a as applyMixinsWithObservables } from './applyMixinsWithObservables.js';
import { s as scrollIntoView } from './scrollIntoView.js';
import { F as FormAssociated } from './form-associated.js';
import { A as AffixIconWithTrailing, a as affixIconTemplateFactory, I as IconWrapper } from './affix.js';
import { L as Localized } from './localized.js';
import { F as FormElementSuccessText, a as FormElementHelperText, e as errorText, f as formElements, g as getFeedbackTemplate } from './form-elements.js';
import { L as Listbox } from './listbox.js';
import { a as applyMixins } from './apply-mixins.js';
import { w as when } from './when.js';
import { r as ref } from './ref.js';
import { s as slotted } from './slotted.js';
import { c as classNames } from './class-names.js';
import { r as repeat } from './repeat.js';

const styles = ".chevron{display:flex;flex-shrink:0;font:var(--vvd-typography-base-extended);transform:rotate(0);transition:transform .2s}:host([aria-expanded=true]) .chevron,:host([open]) .chevron{transform:rotate(180deg)}:not(.disabled) .chevron{cursor:pointer}.disabled .chevron{color:var(--_low-ink-color);cursor:not-allowed}:host(:focus-visible){outline:none}:host{display:inline-block;inline-size:300px;--_low-ink-color: var(--vvd-color-neutral-600)}:host([disabled]){--_low-ink-color: var(--vvd-color-neutral-400);cursor:not-allowed}.control-wrapper{display:flex;flex-direction:column;gap:4px}.label{color:var(--vvd-color-canvas-text);font:var(--vvd-typography-base)}.fieldset{--_connotation-color-primary: var(--vvd-searchable-select-accent-primary, var(--vvd-color-canvas-text));--_connotation-color-primary-text: var(--vvd-searchable-select-accent-primary-text, var(--vvd-color-canvas));--_connotation-color-primary-increment: var(--vvd-searchable-select-accent-primary-increment, var(--vvd-color-neutral-800));--_connotation-color-intermediate: var(--vvd-searchable-select-accent-intermediate, var(--vvd-color-neutral-500));--_connotation-color-faint: var(--vvd-searchable-select-accent-faint, var(--vvd-color-neutral-50));--_connotation-color-soft: var(--vvd-searchable-select-accent-soft, var(--vvd-color-neutral-100));--_connotation-color-firm: var(--vvd-searchable-select-accent-firm, var(--vvd-color-canvas-text));--_connotation-color-fierce: var(--vvd-searchable-select-accent-fierce, var(--vvd-color-neutral-700))}.fieldset{--_appearance-color-text: var(--vvd-color-canvas-text);--_appearance-color-fill: var(--vvd-color-canvas);--_appearance-color-outline: var(--_connotation-color-intermediate)}.fieldset.appearance-ghost{--_appearance-color-text: var(--_connotation-color-firm);--_appearance-color-fill: transparent;--_appearance-color-outline: transparent}.fieldset:where(.hover,:hover):where(:not(.disabled,:disabled,.readonly)){--_appearance-color-text: var(--vvd-color-canvas-text);--_appearance-color-fill: var(--vvd-color-canvas);--_appearance-color-outline: var(--_connotation-color-fierce)}.fieldset:where(.hover,:hover):where(:not(.disabled,:disabled,.readonly)).appearance-ghost{--_appearance-color-text: var(--_connotation-color-firm);--_appearance-color-fill: var(--_connotation-color-faint);--_appearance-color-outline: transparent}.fieldset:where(.disabled,:disabled){--_appearance-color-text: var(--vvd-color-neutral-300);--_appearance-color-fill: var(--vvd-color-neutral-100);--_appearance-color-outline: var(--vvd-color-neutral-300)}.fieldset:where(.disabled,:disabled).appearance-ghost{--_appearance-color-text: var(--vvd-color-neutral-300);--_appearance-color-fill: transparent;--_appearance-color-outline: transparent}.fieldset:where(.readonly):where(:not(.disabled,:disabled)){--_appearance-color-text: var(--vvd-color-canvas-text);--_appearance-color-fill: var(--vvd-color-neutral-200);--_appearance-color-outline: var(--vvd-color-neutral-400)}.fieldset:where(.readonly):where(:not(.disabled,:disabled)).appearance-ghost{--_appearance-color-text: var(--vvd-color-neutral-600);--_appearance-color-fill: transparent;--_appearance-color-outline: transparent}.fieldset:where(.error):where(:not(.disabled,:disabled)){--_appearance-color-text: notSet;--_appearance-color-fill: var(--vvd-color-alert-50);--_appearance-color-outline: var(--vvd-color-alert-500)}.fieldset:where(.error):where(:not(.disabled,:disabled)).appearance-ghost{--_appearance-color-text: notSet;--_appearance-color-fill: var(--vvd-color-alert-50);--_appearance-color-outline: transparent}.fieldset:where(.success):where(:not(.disabled,:disabled)){--_appearance-color-text: notSet;--_appearance-color-fill: var(--vvd-color-success-50);--_appearance-color-outline: var(--vvd-color-success-500)}.fieldset:where(.success):where(:not(.disabled,:disabled)).appearance-ghost{--_appearance-color-text: notSet;--_appearance-color-fill: var(--vvd-color-success-50);--_appearance-color-outline: transparent}.fieldset{display:flex;align-items:center;justify-content:space-between;background-color:var(--_appearance-color-fill);box-shadow:inset 0 0 0 1px var(--_appearance-color-outline);color:var(--_appearance-color-text);font:var(--vvd-typography-base);gap:8px;padding-block:8px;padding-inline:16px;transition:box-shadow .2s,background-color .2s}.fieldset:focus-within{box-shadow:inset 0 0 0 3px var(--focus-stroke-gap-color, currentColor);outline:2px solid var(--focus-stroke-color, var(--vvd-color-canvas-text));outline-offset:calc(-2px - var(--focus-inset, 0px));--focus-stroke-gap-color: transparent}:host(:not([shape=pill])) .fieldset{border-radius:8px}:host([shape=pill]) .fieldset{border-radius:24px}.popup-wrapper{position:relative}.content-area{display:flex;overflow:hidden;flex:1;flex-direction:column;gap:8px;min-block-size:24px}.tag-row{display:flex;gap:8px;inline-size:100%}.tag-row.contains-only-input:not(:focus-within){display:contents}.tag-wrapper{overflow:hidden}.tag{max-inline-size:100%}input{box-sizing:border-box;flex:1;border:none;background:none;block-size:24px;font:var(--vvd-typography-base);max-inline-size:100%;min-inline-size:100px;outline:none}.contains-only-input input:not(:focus){position:absolute;block-size:0;inline-size:0;min-inline-size:0;opacity:0;pointer-events:none}.listbox{display:flex;flex-direction:column;padding:4px;gap:2px;max-block-size:var(--searchable-select-height, 408px);overflow-y:auto}.empty-message{display:flex;align-items:center;justify-content:center;color:var(--vvd-color-neutral-300);min-block-size:40px;text-align:center}::part(popup-base){inline-size:max-content;min-inline-size:var(--_searchable-select-fixed-width, 100%)}slot[name=icon]{font-size:20px}.visually-hidden{position:absolute;overflow:hidden;width:1px;height:1px;clip:rect(0 0 0 0);clip-path:inset(50%);white-space:nowrap}";

const optionTagStyles = ".base{--_connotation-color-contrast: var(--vvd-option-tag-accent-contrast, var(--vvd-color-neutral-800))}.base{position:relative;display:inline-flex;box-sizing:border-box;align-items:center;background-color:var(--fill-color);block-size:calc(1px*(24 + 4*clamp(-1,var(--vvd-size-density, 0),2)));box-shadow:inset 0 0 0 1px var(--outline-color);color:var(--text-color);column-gap:8px;font:var(--vvd-typography-base-bold);max-inline-size:100%;padding-inline:8px;user-select:none;vertical-align:middle}.base:not(.disabled){--text-color: var(--_connotation-color-contrast);--fill-color: color-mix( in srgb, var(--_connotation-color-contrast), transparent 87.5% );--outline-color: transparent}.base.disabled{--text-color: var(--vvd-color-neutral-300);--fill-color: color-mix( in srgb, var(--vvd-color-neutral-800), transparent 87.5% );--outline-color: transparent}.base:not(.shape-pill){border-radius:4px}.base.shape-pill{border-radius:16px}.label{overflow:hidden;max-inline-size:100%;text-overflow:ellipsis;white-space:nowrap}slot[name=icon]{font-size:calc(calc(1px*(24 + 4*clamp(-1,var(--vvd-size-density, 0),2))) / 1.5);line-height:1}.icon-placeholder{inline-size:calc(calc(1px*(24 + 4*clamp(-1,var(--vvd-size-density, 0),2))) / 1.5)}.remove-button{display:flex;align-items:center;border-radius:inherit;cursor:pointer;outline:none}.disabled .remove-button{pointer-events:none}.remove-button:focus-visible:before{--focus-stroke-gap-color: transparent;box-shadow:inset 0 0 0 3px var(--focus-stroke-gap-color, currentColor);outline:2px solid var(--focus-stroke-color, var(--vvd-color-canvas-text));outline-offset:calc(-2px - var(--focus-inset, 0px));position:absolute;z-index:1;display:block;border-radius:inherit;content:\"\";inset:0;pointer-events:none}";

class _SearchableSelect extends VividElement {
}
class FormAssociatedSearchableSelect extends FormAssociated(
  _SearchableSelect
) {
  constructor() {
    super(...arguments);
    this.proxy = document.createElement("input");
  }
}

var __defProp$1 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __decorateClass$1 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1(target, key, result);
  return result;
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _SearchableSelect_instances, updateValuesThroughUserInteraction_fn, updateValuesWhileMaintainingOrder_fn, isValidValue_fn, _slottedOptionsChangeHandler, updateSelectedOnSlottedOptions_fn, handleOptionInteraction_fn, _clonedTagIcons, tagIconOfOption_fn, updateClonedTagIconOfOption_fn, _suppressFilter, updateFilteredOptions_fn, transitionHighlightedOptionTo_fn, selectHighlightedOption_fn, highlightFirstOption_fn, highlightLastOption_fn, highlightPrevPage_fn, highlightNextPage_fn, highlightPreviousOption_fn, highlightNextOption_fn, textForValue_fn, measureTagWidth_fn, updateTagLayout_fn, moveTagFocusTo_fn, nextTagIndexLeft_fn, nextTagIndexRight_fn, nextTagIndexForRemoved_fn, determineInitialValues_fn, updateFormValue_fn, _resizeObserver;
const TagGapPx = 8;
const InputMinWidthPx = 100;
const PageSize = 10;
const isFormAssociatedTryingToSetFormValue = (value) => typeof value === "string";
let SearchableSelect = class extends FormAssociatedSearchableSelect {
  constructor() {
    super(...arguments);
    __privateAdd(this, _SearchableSelect_instances);
    this.fixedDropdown = false;
    this.open = false;
    this.multiple = false;
    this.externalTags = false;
    this.maxLines = null;
    this.values = [];
    this.initialValues = [];
    this._inputValue = "";
    // --- Slotted options ---
    /**
     * @internal
     */
    this._areOptionsInitialized = false;
    __privateAdd(this, _slottedOptionsChangeHandler, {
      handleChange: (source, _) => {
        if (source.selected && !this.values.includes(source.value)) {
          this.values = [...this.values, source.value];
        } else if (!source.selected && this.values.includes(source.value)) {
          this.values = this.values.filter((option) => option !== source.value);
        }
      }
    });
    // --- Option tag icons ---
    __privateAdd(this, _clonedTagIcons, /* @__PURE__ */ new Map());
    this._filteredOptions = [];
    this._filteredEnabledOptions = [];
    __privateAdd(this, _suppressFilter, false);
    this._highlightedOptionIndex = null;
    this._numElidedTags = 0;
    this._tagRows = [];
    this._lastTagRow = [];
    this.clearable = false;
    this.setFormValue = (value, state) => {
      if (isFormAssociatedTryingToSetFormValue(value)) {
        return;
      }
      super.setFormValue(value, state);
    };
    this._changeDescription = "";
    // --- Core ---
    __privateAdd(this, _resizeObserver, new ResizeObserver(() => {
      __privateMethod(this, _SearchableSelect_instances, updateTagLayout_fn).call(this);
    }));
  }
  /**
   * @internal
   */
  openChanged() {
    if (!this.open) {
      __privateMethod(this, _SearchableSelect_instances, transitionHighlightedOptionTo_fn).call(this, null);
    }
  }
  /**
   * @internal
   */
  valuesChanged() {
    if (!this._areOptionsInitialized) {
      return;
    }
    if (!this.multiple && this.values.length > 1) {
      this.values = [this.values[0]];
      return;
    }
    if (this.values.some((value) => !__privateMethod(this, _SearchableSelect_instances, isValidValue_fn).call(this, value))) {
      this.values = this.values.filter((value) => __privateMethod(this, _SearchableSelect_instances, isValidValue_fn).call(this, value));
      return;
    }
    if (!this.multiple) {
      if (this.values.length) {
        __privateSet(this, _suppressFilter, true);
        this._inputValue = __privateMethod(this, _SearchableSelect_instances, textForValue_fn).call(this, this.values[0]);
      } else {
        this._inputValue = "";
      }
    }
    this.value = this.values.length ? this.values[0] : "";
    __privateMethod(this, _SearchableSelect_instances, updateSelectedOnSlottedOptions_fn).call(this);
    if (this.$fastController.isConnected) {
      __privateMethod(this, _SearchableSelect_instances, updateTagLayout_fn).call(this);
    }
    __privateMethod(this, _SearchableSelect_instances, updateFormValue_fn).call(this);
  }
  /**
   * @internal
   */
  initialValuesChanged() {
    if (!this.dirtyValue) {
      this.values = this.initialValues;
      this.dirtyValue = false;
    }
  }
  /**
   * @internal
   */
  valueChanged(prev, next) {
    super.valueChanged(prev, next);
    if (!this._areOptionsInitialized) {
      return;
    }
    const isValidValue = this._slottedOptions.some(
      (option) => option.value === next
    );
    if (this.values[0] !== next) {
      this.values = isValidValue ? [next] : [];
    }
  }
  get selectedIndex() {
    if (this.values.length) {
      return this._slottedOptions.findIndex(
        (option) => option.value === this.values[0]
      );
    } else {
      return -1;
    }
  }
  set selectedIndex(index) {
    this.value = this._slottedOptions[index]?.value ?? "";
  }
  get options() {
    return [...this._slottedOptions];
  }
  get selectedOptions() {
    return this._slottedOptions.filter(
      (option) => this.values.includes(option.value)
    );
  }
  /**
   * @internal
   */
  _inputValueChanged() {
    __privateMethod(this, _SearchableSelect_instances, updateFilteredOptions_fn).call(this);
  }
  /**
   * @internal
   */
  _onInputInput(event) {
    __privateSet(this, _suppressFilter, false);
    this._inputValue = event.target.value;
  }
  /**
   * @internal
   */
  _onInputFocus(_) {
    __privateSet(this, _suppressFilter, true);
    __privateMethod(this, _SearchableSelect_instances, updateFilteredOptions_fn).call(this);
    this.open = true;
  }
  /**
   * @internal
   */
  _onInputBlur(_) {
    this.open = false;
    if (this.multiple) {
      this._inputValue = "";
    } else {
      if (this.values.length === 0) {
        this._inputValue = "";
      } else {
        this._inputValue = __privateMethod(this, _SearchableSelect_instances, textForValue_fn).call(this, this.values[0]);
      }
    }
    this._changeDescription = "";
  }
  /**
   * @internal
   */
  _onInputKeydown(e) {
    if (e.ctrlKey || e.shiftKey) {
      return true;
    }
    switch (e.key) {
      case "Enter":
        __privateMethod(this, _SearchableSelect_instances, selectHighlightedOption_fn).call(this);
        return false;
      case "Escape":
        this.open = false;
        break;
      case "Home":
        if (!this.open) {
          this.open = true;
          break;
        }
        __privateMethod(this, _SearchableSelect_instances, highlightFirstOption_fn).call(this);
        return false;
      case "End":
        if (!this.open) {
          this.open = true;
          break;
        }
        __privateMethod(this, _SearchableSelect_instances, highlightLastOption_fn).call(this);
        return false;
      case "PageUp":
        if (!this.open) {
          this.open = true;
          break;
        }
        __privateMethod(this, _SearchableSelect_instances, highlightPrevPage_fn).call(this);
        return false;
      case "PageDown":
        if (!this.open) {
          this.open = true;
          break;
        }
        __privateMethod(this, _SearchableSelect_instances, highlightNextPage_fn).call(this);
        return false;
      case "ArrowUp":
        if (!this.open) {
          this.open = true;
          break;
        }
        __privateMethod(this, _SearchableSelect_instances, highlightPreviousOption_fn).call(this);
        return false;
      case "ArrowDown":
        if (!this.open) {
          this.open = true;
          break;
        }
        __privateMethod(this, _SearchableSelect_instances, highlightNextOption_fn).call(this);
        return false;
      case "ArrowLeft":
        if (this.multiple && this._inputValue === "" && this.values.length && !this.externalTags) {
          __privateMethod(this, _SearchableSelect_instances, moveTagFocusTo_fn).call(this, __privateMethod(this, _SearchableSelect_instances, nextTagIndexLeft_fn).call(this, this.values.length));
          return false;
        }
        return true;
      case "Backspace":
        if (this.multiple && this._inputValue === "" && this.values.length) {
          this._onTagRemoved(this.values[this.values.length - 1]);
          return false;
        }
        return true;
      default:
        if (!this.open) {
          this.open = true;
        }
        return true;
    }
    return true;
  }
  /**
   * @internal
   */
  _slottedOptionsChanged(oldValue, newValue) {
    const hasSlottedOptions = Boolean(
      this.querySelectorAll(`:not([slot])`).length
    );
    if (!newValue.length && hasSlottedOptions) {
      return;
    }
    this._areOptionsInitialized = true;
    if (oldValue) {
      for (const option of oldValue) {
        const notifier = Observable.getNotifier(option);
        notifier.unsubscribe(__privateGet(this, _slottedOptionsChangeHandler), "selected");
      }
    }
    if (newValue) {
      for (const option of newValue) {
        option._displayCheckmark = true;
        const notifier = Observable.getNotifier(option);
        notifier.subscribe(__privateGet(this, _slottedOptionsChangeHandler), "selected");
      }
    }
    const values = [];
    for (const option of this._slottedOptions) {
      if (option.selected || option.value === this.value || this.values.includes(option.value)) {
        values.push(option.value);
      }
    }
    __privateMethod(this, _SearchableSelect_instances, updateValuesWhileMaintainingOrder_fn).call(this, values);
    __privateMethod(this, _SearchableSelect_instances, updateFilteredOptions_fn).call(this);
  }
  /**
   * @internal
   */
  _tagIconSlotName(value) {
    return `_tag-icon-${this.values.indexOf(value)}`;
  }
  // --- Tags ---
  /**
   * @internal
   */
  _tagLabelForValue(value) {
    const option = this._slottedOptions.find(
      (option2) => option2.value === value
    );
    return option.label;
  }
  /**
   * @internal
   */
  _isTagDisabled(value) {
    const option = this._slottedOptions.find(
      (option2) => option2.value === value
    );
    return this.disabled || option.disabled;
  }
  /**
   * @internal
   */
  _onTagRemoved(value) {
    __privateMethod(this, _SearchableSelect_instances, updateValuesThroughUserInteraction_fn).call(this, this.values.filter((option) => option !== value));
    __privateMethod(this, _SearchableSelect_instances, updateFilteredOptions_fn).call(this);
  }
  /**
   * @internal
   */
  _onTagKeydown(event) {
    const tagIndex = parseInt(event.target.dataset.index);
    switch (event.key) {
      case "Backspace":
      case "Delete":
      case "Enter":
      case " ": {
        this._onTagRemoved(this.values[tagIndex]);
        DOM.processUpdates();
        __privateMethod(this, _SearchableSelect_instances, moveTagFocusTo_fn).call(this, __privateMethod(this, _SearchableSelect_instances, nextTagIndexForRemoved_fn).call(this, tagIndex));
        break;
      }
      case "ArrowLeft":
        __privateMethod(this, _SearchableSelect_instances, moveTagFocusTo_fn).call(this, __privateMethod(this, _SearchableSelect_instances, nextTagIndexLeft_fn).call(this, tagIndex) ?? tagIndex);
        break;
      case "ArrowRight":
        __privateMethod(this, _SearchableSelect_instances, moveTagFocusTo_fn).call(this, __privateMethod(this, _SearchableSelect_instances, nextTagIndexRight_fn).call(this, tagIndex));
        break;
    }
    return true;
  }
  /**
   * @internal
   */
  _onListboxClick(e) {
    if (this.disabled) {
      return;
    }
    const capturedOption = e.target.closest(
      `option,[role=option]`
    );
    if (capturedOption && !capturedOption.disabled) {
      __privateMethod(this, _SearchableSelect_instances, handleOptionInteraction_fn).call(this, capturedOption);
    }
  }
  /**
   * @internal
   */
  get _shouldShowClearButton() {
    return this.clearable && this.values.length > 0;
  }
  /**
   * @internal
   */
  _onClearButtonClick() {
    __privateMethod(this, _SearchableSelect_instances, updateValuesThroughUserInteraction_fn).call(this, this.selectedOptions.filter((option) => option.disabled).map((option) => option.value));
  }
  /**
   * @internal
   */
  nameChanged(previous, next) {
    super.nameChanged(previous, next);
    __privateMethod(this, _SearchableSelect_instances, updateFormValue_fn).call(this);
  }
  /**
   * @internal
   */
  formResetCallback() {
    super.formResetCallback();
    __privateMethod(this, _SearchableSelect_instances, updateValuesThroughUserInteraction_fn).call(this, __privateMethod(this, _SearchableSelect_instances, determineInitialValues_fn).call(this));
  }
  /**
   * @internal
   */
  _onFieldsetClick(e) {
    if (this.disabled) {
      return;
    }
    if (!e.defaultPrevented) {
      this._input.focus();
      this.open = true;
    }
  }
  /**
   * @internal
   */
  _onChevronClick() {
    if (this.open) {
      this.open = false;
      return false;
    }
    return true;
  }
  connectedCallback() {
    super.connectedCallback();
    if (!this.values.length) {
      this.values = __privateMethod(this, _SearchableSelect_instances, determineInitialValues_fn).call(this);
    }
    __privateGet(this, _resizeObserver).observe(this._contentArea);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    __privateGet(this, _resizeObserver).disconnect();
  }
  /**
   * @internal
   */
  validate() {
    super.validate(this._input ?? void 0);
  }
  /**
   * @internal
   */
  focus(options) {
    this._input?.focus(options);
  }
  /**
   * @internal
   */
  _onMouseDown(event) {
    if (!event.defaultPrevented) {
      this._input.focus();
      return false;
    }
    return true;
  }
};
_SearchableSelect_instances = new WeakSet();
updateValuesThroughUserInteraction_fn = function(newValues) {
  this.values = newValues;
  this.$emit("change", void 0, {
    bubbles: false
  });
  this.$emit("input", void 0, {
    bubbles: false
  });
};
updateValuesWhileMaintainingOrder_fn = function(newValues) {
  const oldSet = new Set(this.values);
  const newSet = new Set(newValues);
  this.values = [...this.values].filter((v) => newSet.has(v)).concat([...newValues].filter((v) => !oldSet.has(v)));
};
isValidValue_fn = function(value) {
  return this._slottedOptions.some((option) => option.value === value);
};
_slottedOptionsChangeHandler = new WeakMap();
updateSelectedOnSlottedOptions_fn = function() {
  for (const option of this._slottedOptions) {
    option.selected = this.values.includes(option.value);
    __privateMethod(this, _SearchableSelect_instances, updateClonedTagIconOfOption_fn).call(this, option);
  }
};
handleOptionInteraction_fn = function(option) {
  const value = option.value;
  let newValues;
  const isSelection = !this.values.includes(value);
  if (this.multiple) {
    if (isSelection) {
      newValues = [...this.values, value];
    } else {
      newValues = this.values.filter((option2) => option2 !== value);
    }
    this._inputValue = "";
  } else {
    if (isSelection) {
      newValues = [value];
      this._inputValue = option.text;
    } else {
      newValues = [];
    }
    this.open = false;
  }
  this._changeDescription = isSelection ? this.locale.searchableSelect.optionSelectedMessage(option.text) : this.locale.searchableSelect.optionDeselectedMessage(option.text);
  __privateMethod(this, _SearchableSelect_instances, updateValuesThroughUserInteraction_fn).call(this, newValues);
};
_clonedTagIcons = new WeakMap();
tagIconOfOption_fn = function(option) {
  return option.querySelector('[slot="tag-icon"]');
};
updateClonedTagIconOfOption_fn = function(option) {
  if (option.selected && __privateMethod(this, _SearchableSelect_instances, tagIconOfOption_fn).call(this, option)) {
    let clone = __privateGet(this, _clonedTagIcons).get(option);
    if (!clone) {
      clone = __privateMethod(this, _SearchableSelect_instances, tagIconOfOption_fn).call(this, option).cloneNode(true);
      __privateGet(this, _clonedTagIcons).set(option, clone);
    }
    clone.slot = this._tagIconSlotName(option.value);
    this.appendChild(clone);
  } else {
    const clone = __privateGet(this, _clonedTagIcons).get(option);
    if (clone) {
      clone.remove();
      __privateGet(this, _clonedTagIcons).delete(option);
    }
  }
};
_suppressFilter = new WeakMap();
updateFilteredOptions_fn = function() {
  const newFilteredOptions = [];
  for (const option of this._slottedOptions ?? []) {
    if (__privateGet(this, _suppressFilter) || this._inputValue === "") {
      option.hidden = false;
      option._matchedRange = null;
    } else {
      const matchIndex = option.text.toLowerCase().indexOf(this._inputValue.toLowerCase());
      const matchedRange = matchIndex === -1 ? null : { from: matchIndex, to: matchIndex + this._inputValue.length };
      option.hidden = !matchedRange;
      option._matchedRange = matchedRange;
    }
    if (!option.hidden) {
      newFilteredOptions.push(option);
    }
  }
  __privateMethod(this, _SearchableSelect_instances, transitionHighlightedOptionTo_fn).call(this, null);
  this._filteredOptions = newFilteredOptions;
  this._filteredEnabledOptions = newFilteredOptions.filter(
    (option) => !option.disabled
  );
};
transitionHighlightedOptionTo_fn = function(index) {
  if (typeof this._highlightedOptionIndex === "number") {
    this._filteredEnabledOptions[this._highlightedOptionIndex]._highlighted = false;
  }
  if (typeof index === "number") {
    if (!this._filteredEnabledOptions.length) {
      index = null;
    } else {
      index = Math.max(
        0,
        Math.min(this._filteredEnabledOptions.length - 1, index)
      );
    }
  }
  this._highlightedOptionIndex = index;
  if (typeof this._highlightedOptionIndex === "number") {
    const highlightedOption = this._filteredEnabledOptions[this._highlightedOptionIndex];
    highlightedOption._highlighted = true;
    scrollIntoView(highlightedOption, this._listbox, "nearest");
    this._changeDescription = this.locale.searchableSelect.optionFocusedMessage(
      highlightedOption.text,
      this._highlightedOptionIndex + 1,
      this._filteredEnabledOptions.length
    );
  }
};
selectHighlightedOption_fn = function() {
  if (this._highlightedOptionIndex === null) {
    return;
  }
  __privateMethod(this, _SearchableSelect_instances, handleOptionInteraction_fn).call(this, this._filteredEnabledOptions[this._highlightedOptionIndex]);
};
highlightFirstOption_fn = function() {
  __privateMethod(this, _SearchableSelect_instances, transitionHighlightedOptionTo_fn).call(this, 0);
};
highlightLastOption_fn = function() {
  __privateMethod(this, _SearchableSelect_instances, transitionHighlightedOptionTo_fn).call(this, this._filteredEnabledOptions.length - 1);
};
highlightPrevPage_fn = function() {
  __privateMethod(this, _SearchableSelect_instances, transitionHighlightedOptionTo_fn).call(this, (this._highlightedOptionIndex ?? this._filteredEnabledOptions.length) - PageSize);
};
highlightNextPage_fn = function() {
  __privateMethod(this, _SearchableSelect_instances, transitionHighlightedOptionTo_fn).call(this, (this._highlightedOptionIndex ?? -1) + PageSize);
};
highlightPreviousOption_fn = function() {
  __privateMethod(this, _SearchableSelect_instances, transitionHighlightedOptionTo_fn).call(this, (this._highlightedOptionIndex ?? this._filteredEnabledOptions.length) - 1);
};
highlightNextOption_fn = function() {
  __privateMethod(this, _SearchableSelect_instances, transitionHighlightedOptionTo_fn).call(this, (this._highlightedOptionIndex ?? -1) + 1);
};
textForValue_fn = function(value) {
  const option = this._slottedOptions.find(
    (option2) => option2.value === value
  );
  return option.text;
};
/**
 * @internal
 */
measureTagWidth_fn = function(label, removable, hasIcon) {
  const tag = document.createElement(this._optionTagTagName);
  tag.label = label;
  tag.removable = removable;
  tag.style.cssText = "position: absolute; visibility: hidden;";
  tag.hasIconPlaceholder = hasIcon;
  this.shadowRoot.appendChild(tag);
  const width = tag.getBoundingClientRect().width;
  tag.remove();
  return width;
};
updateTagLayout_fn = function() {
  if (!this.multiple) {
    this._numElidedTags = 0;
    this._tagRows = [];
    this._lastTagRow = [];
    return;
  }
  if (this.externalTags) {
    this._numElidedTags = this.values.length;
    this._tagRows = [];
    this._lastTagRow = [];
    return;
  }
  const rowWidth = this._contentArea.getBoundingClientRect().width;
  const rows = [[]];
  let currentRowIndex = 0;
  let currentRowWidth = InputMinWidthPx;
  let i;
  for (i = this.values.length - 1; i >= 0; i--) {
    const isLastRow = this.maxLines && currentRowIndex === this.maxLines - 1;
    const tagWidth = __privateMethod(this, _SearchableSelect_instances, measureTagWidth_fn).call(this, this._tagLabelForValue(this.values[i]), true, __privateMethod(this, _SearchableSelect_instances, tagIconOfOption_fn).call(this, this.selectedOptions[i]) !== null);
    const entry = {
      value: this.values[i],
      width: tagWidth
    };
    let elidedTagCounterWidth = 0;
    if (isLastRow) {
      const numElidedTags = i;
      if (numElidedTags) {
        elidedTagCounterWidth = TagGapPx + __privateMethod(this, _SearchableSelect_instances, measureTagWidth_fn).call(this, numElidedTags.toString(), false, false);
      }
    }
    const totalWidthNeeded = currentRowWidth + TagGapPx + tagWidth + elidedTagCounterWidth;
    if (totalWidthNeeded > rowWidth) {
      if (isLastRow) {
        if (i === this.values.length - 1) {
          rows[currentRowIndex].unshift(entry);
          currentRowWidth += TagGapPx + tagWidth;
        } else {
          break;
        }
      } else {
        rows.push([]);
        currentRowIndex++;
        rows[currentRowIndex].unshift(entry);
        currentRowWidth = tagWidth;
      }
      continue;
    }
    rows[currentRowIndex].unshift(entry);
    currentRowWidth += TagGapPx + tagWidth;
  }
  this._numElidedTags = i + 1;
  rows.reverse();
  for (let i2 = 0; i2 < rows.length - 1; i2++) {
    let lineWidth = rows[i2].map((e) => e.width).reduce((a, b) => a + b, 0) + (rows[i2].length - 1) * TagGapPx;
    if (i2 === 0 && this._numElidedTags) {
      lineWidth += TagGapPx + __privateMethod(this, _SearchableSelect_instances, measureTagWidth_fn).call(this, this._numElidedTags.toString(), false, false);
    }
    while (rows[i2 + 1].length && lineWidth + TagGapPx + rows[i2 + 1][0].width <= rowWidth) {
      const nextTag = rows[i2 + 1].shift();
      rows[i2].push(nextTag);
      lineWidth += TagGapPx + nextTag.width;
    }
  }
  const rowValues = rows.map((line) => line.map((entry) => entry.value));
  this._tagRows = rowValues.slice(0, -1);
  this._lastTagRow = rowValues.slice(-1)[0];
};
moveTagFocusTo_fn = function(index) {
  if (index === null) {
    this._input.focus();
  } else {
    this.shadowRoot.querySelector(`[data-index="${index}"]`)?.focus();
  }
};
nextTagIndexLeft_fn = function(index) {
  if (!this.values.length) {
    return null;
  }
  for (let i = index - 1; i >= 0; i--) {
    if (!this._isTagDisabled(this.values[i])) {
      return i;
    }
  }
  return null;
};
nextTagIndexRight_fn = function(index) {
  if (!this.values.length) {
    return null;
  }
  for (let i = index + 1; i < this.values.length; i++) {
    if (!this._isTagDisabled(this.values[i])) {
      return i;
    }
  }
  return null;
};
nextTagIndexForRemoved_fn = function(index) {
  return __privateMethod(this, _SearchableSelect_instances, nextTagIndexRight_fn).call(this, index - 1) ?? __privateMethod(this, _SearchableSelect_instances, nextTagIndexLeft_fn).call(this, index);
};
// --- Form handling ---
determineInitialValues_fn = function() {
  return this.initialValues.length ? this.initialValues : this.initialValue ? [this.initialValue] : [];
};
updateFormValue_fn = function() {
  if (!this.name) {
    this.setFormValue(null);
  } else {
    const formData = new FormData();
    for (const value of this.values) {
      formData.append(this.name, value);
    }
    this.setFormValue(formData);
  }
};
_resizeObserver = new WeakMap();
__decorateClass$1([
  attr
], SearchableSelect.prototype, "appearance", 2);
__decorateClass$1([
  attr
], SearchableSelect.prototype, "shape", 2);
__decorateClass$1([
  attr({ mode: "boolean", attribute: "fixed-dropdown" })
], SearchableSelect.prototype, "fixedDropdown", 2);
__decorateClass$1([
  attr
], SearchableSelect.prototype, "placeholder", 2);
__decorateClass$1([
  attr({ mode: "boolean" })
], SearchableSelect.prototype, "open", 2);
__decorateClass$1([
  attr({ mode: "boolean" })
], SearchableSelect.prototype, "multiple", 2);
__decorateClass$1([
  attr({ attribute: "external-tags", mode: "boolean" })
], SearchableSelect.prototype, "externalTags", 2);
__decorateClass$1([
  attr({ attribute: "max-lines", converter: nullableNumberConverter })
], SearchableSelect.prototype, "maxLines", 2);
__decorateClass$1([
  observable
], SearchableSelect.prototype, "values", 2);
__decorateClass$1([
  observable
], SearchableSelect.prototype, "initialValues", 2);
__decorateClass$1([
  observable
], SearchableSelect.prototype, "_input", 2);
__decorateClass$1([
  observable
], SearchableSelect.prototype, "_inputValue", 2);
__decorateClass$1([
  observable
], SearchableSelect.prototype, "_slottedOptions", 2);
__decorateClass$1([
  observable
], SearchableSelect.prototype, "_filteredOptions", 2);
__decorateClass$1([
  observable
], SearchableSelect.prototype, "_filteredEnabledOptions", 2);
__decorateClass$1([
  observable
], SearchableSelect.prototype, "_highlightedOptionIndex", 2);
__decorateClass$1([
  observable
], SearchableSelect.prototype, "_contentArea", 2);
__decorateClass$1([
  observable
], SearchableSelect.prototype, "_numElidedTags", 2);
__decorateClass$1([
  observable
], SearchableSelect.prototype, "_tagRows", 2);
__decorateClass$1([
  observable
], SearchableSelect.prototype, "_lastTagRow", 2);
__decorateClass$1([
  observable
], SearchableSelect.prototype, "_listbox", 2);
__decorateClass$1([
  attr({ mode: "boolean" })
], SearchableSelect.prototype, "clearable", 2);
__decorateClass$1([
  observable
], SearchableSelect.prototype, "_changeDescription", 2);
__decorateClass$1([
  observable
], SearchableSelect.prototype, "_anchor", 2);
SearchableSelect = __decorateClass$1([
  errorText,
  formElements
], SearchableSelect);
applyMixinsWithObservables(
  SearchableSelect,
  AffixIconWithTrailing,
  FormElementHelperText,
  FormElementSuccessText,
  Localized
);

var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0 ;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (decorator(target, key, result) ) || result;
  if (result) __defProp(target, key, result);
  return result;
};
class OptionTag extends VividElement {
  constructor() {
    super(...arguments);
    this.removable = false;
    this.disabled = false;
    this.hasIconPlaceholder = false;
  }
  _onClickRemove() {
    this.$emit("remove", void 0, {
      bubbles: false
    });
  }
}
__decorateClass([
  attr
], OptionTag.prototype, "shape");
__decorateClass([
  attr
], OptionTag.prototype, "label");
__decorateClass([
  attr({ mode: "boolean" })
], OptionTag.prototype, "removable");
__decorateClass([
  attr({ mode: "boolean" })
], OptionTag.prototype, "disabled");
__decorateClass([
  observable
], OptionTag.prototype, "hasIconPlaceholder");
applyMixins(OptionTag, Localized);

const getStateClasses = (x) => classNames(
  ["disabled", x.disabled],
  [`appearance-${x.appearance}`, Boolean(x.appearance)],
  [`shape-${x.shape}`, Boolean(x.shape)],
  ["error", Boolean(x.errorValidationMessage)],
  ["success", !!x.successText]
);
function renderLabel() {
  return html`
		<label for="control" class="label" id="label"> ${(x) => x.label} </label>
	`;
}
const tagTemplateFactory = (context, getComponent) => {
  const optionTagTag = context.tagFor(OptionTag);
  return html`
		<div class="tag-wrapper">
			<${optionTagTag}
				class="tag"
				tabindex="-1"
				data-index="${(x, c) => getComponent(c).values.indexOf(x)}"
				removable
				:label="${(x, c) => getComponent(c)._tagLabelForValue(x)}"
				:shape="${(_, c) => getComponent(c).shape}"
				?disabled="${(x, c) => getComponent(c)._isTagDisabled(x)}"
				@remove="${(x, c) => getComponent(c)._onTagRemoved(x)}"
				@keydown="${(_, c) => getComponent(c)._onTagKeydown(c.event)}"
				@mousedown="${() => false}">
				<slot slot="icon" name="${(x, c) => getComponent(c)._tagIconSlotName(x)}"></slot>
			</${optionTagTag}>
		</div>
	`;
};
const elidedTagTemplateFactory = (context, getComponent) => {
  const optionTagTag = context.tagFor(OptionTag);
  return html`
		<${optionTagTag}
			class="tag"
			tabindex="-1"
			:label="${(x, c) => getComponent(x, c)._numElidedTags.toString()}"
			:shape="${(x, c) => getComponent(x, c).shape}"
			?disabled="${(x, c) => getComponent(x, c).disabled}"
			@mousedown="${() => false}">
		</${optionTagTag}>
	`;
};
function renderFieldset(context) {
  const buttonTag = context.tagFor(Button);
  const affixIconTemplate = affixIconTemplateFactory(context);
  const chevronTemplate = chevronTemplateFactory(context);
  const tagTemplate = tagTemplateFactory(context, (c) => c.parent);
  const nestedTagTemplate = tagTemplateFactory(
    context,
    (c) => c.parentContext.parent
  );
  const elidedTagTemplate = elidedTagTemplateFactory(context, (x, _) => x);
  const nestedElidedTagTemplate = elidedTagTemplateFactory(
    context,
    (_, c) => c.parent
  );
  return html`
		<div
			class="fieldset ${getStateClasses}"
			@click="${(x, c) => x._onFieldsetClick(c.event)}"
			${ref("_anchor")}
		>
			${(x) => affixIconTemplate(x.icon, IconWrapper.Slot)}
			<div class="content-area" ${ref("_contentArea")}>
				${repeat(
    (x) => x._tagRows,
    html`
						<div class="tag-row">
							${when(
      (_, c) => c.isFirst && c.parent._numElidedTags,
      nestedElidedTagTemplate
    )}
							${repeat((x) => x, nestedTagTemplate)}
						</div>
					`,
    { positioning: true }
  )}
				<div
					class="tag-row ${(x) => classNames([
    "contains-only-input",
    x._tagRows.length > 0 && x._lastTagRow.length === 0
  ])}"
				>
					${when(
    (x) => x._tagRows.length === 0 && x._numElidedTags,
    elidedTagTemplate
  )}
					${repeat((x) => x._lastTagRow, tagTemplate)}
					<input
						id="control"
						class="control"
						autocomplete="off"
						aria-autocomplete="list"
						aria-expanded="${(x) => x.open}"
						aria-haspopup="listbox"
						aria-controls="listbox"
						placeholder="${(x) => x.multiple && x.values.length ? "" : x.placeholder}"
						role="combobox"
						type="text"
						?disabled="${(x) => x.disabled}"
						:value="${(x) => x._inputValue}"
						@input="${(x, c) => x._onInputInput(c.event)}"
						@focus="${(x, c) => x._onInputFocus(c.event)}"
						@blur="${(x, c) => x._onInputBlur(c.event)}"
						@keydown="${(x, c) => x._onInputKeydown(c.event)}"
						${ref("_input")}
					/>
				</div>
			</div>
			<slot name="meta"></slot>
			${when(
    (x) => x._shouldShowClearButton,
    html`<${buttonTag}
					aria-label="${(x) => x.locale.searchableSelect.clearButtonLabel}"
					@click="${(x) => x._onClearButtonClick()}"
					@mousedown="${() => false}"
					?disabled="${(x) => x.disabled}"
					:shape="${(x) => x.shape}"
					size="super-condensed"
					icon="close-line"
					appearance="ghost-light"
					tabindex="-1"
				></${buttonTag}>`
  )}
			<div @mousedown="${() => false}" @click="${(x) => x._onChevronClick()}">
				${chevronTemplate}
			</div>
		</div>
	`;
}
function setFixedDropdownVarWidth(x) {
  return x.open && x.fixedDropdown ? `--_searchable-select-fixed-width: ${Math.round(
    x.getBoundingClientRect().width
  )}px` : null;
}
function renderControl(context) {
  const popupTag = context.tagFor(Popup);
  return html`
		${when((x) => x.label, renderLabel())}
		<span aria-live="assertive" aria-relevant="text" class="visually-hidden">
			${(x) => x._changeDescription}
		</span>
		<div>
			${renderFieldset(context)}
			<div class="popup-wrapper">
				<${popupTag}
					:anchor="${(x) => x._anchor}"
					:open="${(x) => x.open}"
					class="popup"
					placement="bottom-start"
					style="${setFixedDropdownVarWidth}"
					strategy="${(x) => x.fixedDropdown ? "fixed" : "absolute"}">
					<div
						class="listbox"
						role="listbox"
						aria-multiselectable="${(x) => x.multiple}"
						aria-required="${(x) => x.required}"
						${ref("_listbox")}
						@click="${(x, c) => x._onListboxClick(c.event)}"
						@mousedown="${() => false}"
					>
						<slot
							${slotted({
    filter: Listbox.slottedOptionFilter,
    flatten: true,
    property: "_slottedOptions"
  })}>
						</slot>
						${when(
    (x) => x._filteredOptions.length === 0,
    html`<div class="empty-message">
								${when(
      (x) => x._inputValue === "",
      html`<slot name="no-options">
										${(x) => x.locale.searchableSelect.noOptionsMessage}
									</slot>`
    )}
								${when(
      (x) => x._inputValue !== "",
      html`<slot name="no-matches">
										${(x) => x.locale.searchableSelect.noMatchesMessage}
									</slot>`
    )}
							</div>`
  )}
					</div>
				</${popupTag}>
			</div>
		</div>
	`;
}
const SearchableSelectTemplate = (context) => {
  const optionTagTag = context.tagFor(OptionTag);
  return html`
		<template
			:_optionTagTagName="${() => optionTagTag}"
			@mousedown="${(x, c) => x._onMouseDown(c.event)}"
		>
			<div class="control-wrapper">
				${renderControl(context)} ${getFeedbackTemplate(context)}
			</div>
		</template>
	`;
};

const getClasses = ({ shape, disabled, removable }) => classNames(
  "base",
  ["disabled", disabled],
  ["removable", removable],
  [`shape-${shape}`, Boolean(shape)]
);
function renderRemoveButton(iconTag) {
  return html`
		<span
			class="remove-button"
			aria-label="${(x) => x.locale.searchableSelect.removeTagButtonLabel(x.label)}"
			role="button"
			tabindex="${(x) => x.disabled ? null : 0}"
			@click="${(x) => x._onClickRemove()}"
		>
			<${iconTag} name="close-line"></${iconTag}>
		</span>
	`;
}
const optionTagTemplate = (context) => {
  const iconTag = context.tagFor(Icon);
  return html`<span class="${getClasses}" aria-disabled="${(x) => x.disabled}">
		<slot name="icon" aria-hidden="true">
			${when(
    (x) => x.hasIconPlaceholder,
    html`<div class="icon-placeholder"></div>`
  )}
		</slot>
		${when(
    (x) => x.label,
    (x) => html`<span class="label">${x.label}</span>`
  )}
		${when((x) => x.removable, renderRemoveButton(iconTag))}
	</span>`;
};

const optionTagDefinition = defineVividComponent(
  "option-tag",
  OptionTag,
  optionTagTemplate,
  [iconDefinition],
  {
    styles: [optionTagStyles],
    shadowOptions: {
      delegatesFocus: true
    }
  }
);
const searchableSelectDefinition = defineVividComponent(
  "searchable-select",
  SearchableSelect,
  SearchableSelectTemplate,
  [buttonDefinition, popupDefinition, iconDefinition, optionTagDefinition],
  {
    styles
  }
);
const registerSearchableSelect = createRegisterFunction(
  searchableSelectDefinition
);

export { SearchableSelect as S, registerSearchableSelect as r };
